import { GenericService } from "../GenericService";

class UserResponseService extends GenericService {
  constructor() {
    super("/api/userResponses/customerResponses");
  }

  customerResponses = (data) =>
    this.post("/api/userResponses/customerResponses", data);
  submitResponse = (data) => this.post("/api/userResponses/addFR", data);
}

export default new UserResponseService();
